import React from "react";
import { useState } from "react";
function Profiles() {
  const [details, setdetails] = useState({
    name: "",
    gst_no: "",
    pan_card: "",
    createdby: "",
    address: "",
    phone_no: "",
  });

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(details);
    const response = await fetch(
      `https://tame-jade-earthworm-belt.cyclic.app/profile/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );
    const json = await response.json();
    console.log(json);
    const inputfield = document.getElementsByClassName("entry");
    Object.entries(inputfield).forEach((element) => {
      element[1].value = "";
    });
  };
  return (
    <div>
      <div>
        <div style={{ width: "600px" }}>
          <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
            <label>
              Name
              <input
                className="entry"
                type="text"
                name="name"
                value={details.name}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Pan-Card Number
              <input
                type="text"
                className="entry"
                name="pan_card"
                value={details.pan_card}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GST Number:
              <input
                type="text"
                name="gst_no"
                className="entry"
                value={details.gst_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Phone Number:
              <input
                type="text"
                name="phone_no"
                className="entry"
                value={details.phone_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Address:
              <input
                type="text"
                className="entry"
                name="address"
                value={details.address}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Created By:
              <input
                type="text"
                className="entry"
                name="createdby"
                value={details.createdby}
                onChange={handleChange}
              />
            </label>
            <br />

            <br />
            <input className="generate" type="submit" value="Add Good " />
          </form>
        </div>
      </div>
    </div>
  );
}

export default Profiles;
